import React from "react";
import { useI18n } from "bananas-commerce-admin";

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";

import { PublishingRuleCreateSchema } from "../../types";

export interface PublishingDaysSectionProps {
  schedule: PublishingRuleCreateSchema;
  setSchedule: React.Dispatch<React.SetStateAction<PublishingRuleCreateSchema>>;
  error?: string;
}

const PublishingDaysSection: React.FC<PublishingDaysSectionProps> = ({
  schedule,
  setSchedule,
  error,
}) => {
  const { t } = useI18n();
  return (
    <Box id="publish-days">
      <Typography gutterBottom variant="subtitle1">
        {t("Utgivningsdagar")}
      </Typography>
      <FormControl component="fieldset" sx={{ width: "100%" }}>
        <Stack alignItems="flex-start" direction="row" spacing={8}>
          <Stack>
            <FormControlLabel
              control={
                <Checkbox
                  checked={schedule.monday}
                  onChange={(e) =>
                    setSchedule((prev) => ({
                      ...prev,
                      monday: e.target.checked,
                    }))
                  }
                />
              }
              label={t("Måndag")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={schedule.tuesday}
                  onChange={(e) =>
                    setSchedule((prev) => ({
                      ...prev,
                      tuesday: e.target.checked,
                    }))
                  }
                />
              }
              label={t("Tisdag")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={schedule.wednesday}
                  onChange={(e) =>
                    setSchedule((prev) => ({
                      ...prev,
                      wednesday: e.target.checked,
                    }))
                  }
                />
              }
              label={t("Onsdag")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={schedule.thursday}
                  onChange={(e) =>
                    setSchedule((prev) => ({
                      ...prev,
                      thursday: e.target.checked,
                    }))
                  }
                />
              }
              label={t("Torsdag")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={schedule.friday}
                  onChange={(e) =>
                    setSchedule((prev) => ({
                      ...prev,
                      friday: e.target.checked,
                    }))
                  }
                />
              }
              label={t("Fredag")}
            />
          </Stack>
          <Stack>
            <FormControlLabel
              control={
                <Checkbox
                  checked={schedule.saturday}
                  onChange={(e) =>
                    setSchedule((prev) => ({
                      ...prev,
                      saturday: e.target.checked,
                    }))
                  }
                />
              }
              label={t("Lördag")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={schedule.sunday}
                  onChange={(e) =>
                    setSchedule((prev) => ({
                      ...prev,
                      sunday: e.target.checked,
                    }))
                  }
                />
              }
              label={t("Söndag")}
            />
          </Stack>
        </Stack>
      </FormControl>
      {error && (
        <Typography color="error" sx={{ mt: 1 }} variant="caption">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default PublishingDaysSection;
